import React from "react";
import user from "./user.svg";
import "./LoggedUser.css";

function LoggedUser() {
  return (
    <div className="userBlock">
      <div className="imgContainer">
        <img src={user} alt="user icon" />
      </div>
      <div className="textContainer">
        <p>
          Logged in as: <span className="boldSpan">Test Test</span>
        </p>
        <p>
          Employee Number: <span className="boldSpan">12345</span>{" "}
        </p>
        <p>
          Department: <span className="boldSpan"> Finance</span>
        </p>
      </div>
    </div>
  );
}

export default LoggedUser;
